import { HTTP as http } from '../../http'

const PREFIX = '/my-account'

export default {

    updateAccount: (data) => {
        return http.post(PREFIX+'/updateAccount', data)
    },
}